import { axios } from '@/utils/request'

// 获取二维码
export function qrCodeApi (params) {
    return axios.get('/qrCode/qrCode?code='+params)
}

export function submitHumanApi (params) {
    return axios.post('/qrCode/submitHuman',params)
}
export function submitPetApi (params) {
    return axios.post('/qrCode/submitPet',params)
}
export function treePageApi (params) {
    return axios.get('/qrCode/treePage',params)
}

export function wxBuyApi (params) {
    return axios.post('/wx/buy',params)
}
export function ordermeApi (params) {
    return axios.get('/wx/orderme?openId='+params)
}
export function productDetailsApi (params) {
    return axios.get('/wx/productDetails?productId='+params)
}
export function orderDetailsApi (params) {
    return axios.get('/wx/orderDetails?openId='+params.openId+"&orderId="+params.orderId)
}
export function wxOrderRedirectApi (params) {
    return axios.get('wx/order')
}

export function wxProductRedirectApi (params) {
    return axios.get('wx/product')
}
export function wxProductListApi (params) {
    return axios.get('wx/productList')
}
export function wxorderAttachmentApi (params) {
    return axios.get('wx/orderAttachment?openId='+params.openId+"&orderId="+params.orderId)
}
export function wxorderAttachmentPreviewApi (params) {
    return axios.get('wx/attachmentPreview?aid='+params)
}

export function wxJsApi (params) {
  return axios.get('/wx/jssdk-config?url='+params)
}







